setLiveAccessNextEvent